
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/silver-rates/[slug]",
      function () {
        return require("private-next-pages/silver-rates/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/silver-rates/[slug]"])
      });
    }
  